import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBots } from "../../../state/actions/catalogue";
import { DotsLoader } from "../../../components/ui/Loader/dotsLoader";
import { setLoader } from "../../../state/actions/loader";
import CatalogBotsContainer from "../BotsContainer";


const FeaturedCatalogContainer = () => {
	const dispatch = useDispatch();
	const bots = useSelector((state) => state.catalogue?.bots || []);
	const isLoading = useSelector((state) => state.loader.loading);

	useEffect(() => {
		dispatch(setLoader(true));
		dispatch(fetchBots({ featured: true }, true));
	}, []);

	return (
		<div className="container-fluid">
			{isLoading ? <DotsLoader />
				:
				<div className="row">
					<CatalogBotsContainer bots={bots} />
				</div>
			}
		</div>
	);
};

export default FeaturedCatalogContainer;
